import React from 'react';
import Button from '../../components/Form/Button';
import type { Job } from './types';
import { getStatusBadge } from './types';

interface JobDetailsModalProps {
  job: Job;
  onClose: () => void;
  onEdit: (job: Job) => void;
}

const JobDetailsModal: React.FC<JobDetailsModalProps> = ({ job, onClose, onEdit }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
    <div className="relative w-full max-w-4xl mx-4 my-8">
      <div className="bg-white rounded-lg shadow-xl">
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-2xl font-semibold text-gray-900">Job Details</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="text-sm font-medium text-gray-500">Job ID</label>
              <p className="mt-1 text-gray-900">{job.id}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Status</label>
              <p className="mt-1">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(job.status)}`}>
                  {job.status}
                </span>
              </p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Job Title</label>
              <p className="mt-1 text-gray-900 font-semibold">{job.title}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Department</label>
              <p className="mt-1 text-gray-900">{job.department}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Location</label>
              <p className="mt-1 text-gray-900">{job.location}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Employment Type</label>
              <p className="mt-1 text-gray-900">{job.type}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Salary Range</label>
              <p className="mt-1 text-gray-900">{job.salary}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Applicants</label>
              <p className="mt-1 text-gray-900">{job.applicants}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Posted Date</label>
              <p className="mt-1 text-gray-900">{job.postedDate}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-500">Deadline</label>
              <p className="mt-1 text-gray-900">{job.deadline}</p>
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-500">Job Description</label>
            <p className="mt-2 text-gray-900 whitespace-pre-wrap">{job.description}</p>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-500">Requirements</label>
            <ul className="mt-2 list-disc list-inside space-y-1">
              {job.requirements.map((req, index) => (
                <li key={index} className="text-gray-900">{req}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex justify-end space-x-3 p-6 border-t bg-gray-50">
          <Button onClick={onClose} variant="secondary">Close</Button>
          <Button onClick={() => { onClose(); onEdit(job); }} variant="primary">Edit Job</Button>
        </div>
      </div>
    </div>
  </div>
);

export default JobDetailsModal;
